import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';

import { FeatureFlagService } from '@core/services/feature-flag.service';
import { FeatureFlag } from '@env/environment.interface';
import { Individual } from '@features/contacts/models/individual';
import { IndividualService } from '@features/contacts/services/individual.service';
import {
  DialogButtonColour,
  DialogComponent
} from '@shared/components/dialog/dialog.component';
import { ModalSetting } from '@shared/components/modal/modal-setting';

@Component({
  selector: 'spark-contacts-individual-summary-panel',
  templateUrl: './individual-summary-panel.component.html',
  styleUrls: ['./individual-summary-panel.component.scss']
})
export class IndividualSummaryPanelComponent {
  @Input() individualSummary!: Individual.Summary;

  modal: BsModalRef | null = null;

  constructor(
    private individualService: IndividualService,
    private modalService: BsModalService,
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  get contactDeletionEnabled(): boolean {
    return this.featureFlagService.isEnabled(FeatureFlag.ContactDeletion);
  }

  delete(): void {
    const initialState = {
      title: 'Delete Contact',
      message: 'This action cannot be undone.',
      buttons: [
        {
          label: 'Cancel',
          action: of([]),
          complete: () => this.closeModal(),
          colour: DialogButtonColour.default
        },
        {
          label: 'Delete',
          action: this.individualService.deleteIndividual(this.individualSummary.id),
          complete: () => this.closeAndReturnToList(),
          colour: DialogButtonColour.danger
        }
      ]
    };
    this.modal = this.modalService.show(
      DialogComponent,
      ModalSetting.createDialog(initialState)
    );
  }

  closeModal() {
    this.modal?.hide();
  }

  closeAndReturnToList() {
    this.closeModal();
    this.router.navigate(['Contacts']);
  }
}
